
















































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhInlineLoader from "@/design-system/shared/JdhInlineLoader.vue"

/**
 * @status stable
 * @published 4.9.0
 * @changelog 4.9.0 Published.
 * @changelog 4.10.0 Add warning status.
 * @changelog 4.10.1 Add solo and icon support.
 * @changelog 5.6.0 Add loading state, and rearrange toolbar on solo mode.
 */
@Component({
    components: {JdhInlineLoader, JdhHeightTransition}
})
export default class JdsSpotlight extends Vue {
    /**
     * Shorthand for the same text in the `label` slot.
     */
    @Prop({default: ''}) label!: string

    /**
     * Icon to show prominently above the main content.
     */
    @Prop() icon!: string

    /**
     * Icon to show nearby the label
     */
    @Prop() iconLabel!: string

    /**
     * Use when the main content area contains a number.
     */
    @Prop({default: false, type: Boolean}) numeric!: boolean

    /**
     * Use when this spotlight is sitting alone on its own, and you _really_ want to draw
     * attention to it.
     */
    @Prop({default: false, type: Boolean}) solo!: boolean

    /**
     * Use `warning` if you need to draw attention to this information; in used,
     * you **must** either ensure either the toolbar or action slot contain a button to resolve this
     * situation, **or** include help text that describes how to do the same.
     */
    @Prop({default: 'normal', type: String}) status!: 'warning'|'normal'

    /**
     * Your everyday boolean loading state.
     */
    @Prop({default: false, type: Boolean}) loading!: boolean

    get rootClasses() {
        let classes = []
        if (this.solo) classes.push('jdsc-spotlight--solo')
        return classes
    }

    get topClasses() {
        let classes = []
        if (this.solo) classes.push('jdsc-spotlight__top--solo')
        return classes
    }

    get mainClasses() {
        let classes = []
        if (this.numeric) classes.push('jdsc-spotlight__main--numeric')
        if (this.status === 'warning') classes.push('jdsc-spotlight__main--warning')
        return classes
    }

    get subClasses() {
        let classes = []
        if (this.status === 'warning') classes.push('jdsc-spotlight__sub--warning')
        return classes
    }
}
